
import * as React from 'react';
import { useEffect, useId, useState } from 'react';

import { apiRequest } from '@/utils/request';
import { NavigationService } from '@/utils/navigation';
import {
    Button,
    Input,
    Label,
    Link,
    Text
} from '@/components/ui';
import { Form } from '@/components/business';

export function LoginForm ({ onOtpRequest, onAlert, onForgotPassword }) {
    const emailInputId = useId();
    const passwordInputId = useId();
    const
        [email, setEmail] = useState(''),
        [formFilled, setFormFilled] = useState(false),
        [loading, setLoading] = useState(false),
        [password, setPassword] = useState('');

    useEffect(() => {
        const formFilled = password !== '' && email !== ''

        setFormFilled(formFilled)
    }, [email, password]);

    const handleForgotPassword = () => {
        onForgotPassword(email)
    };

    const handleSubmit = async (event) => {
        event.preventDefault()
        setLoading(true)

        const data = {
            email,
            password
        }

        try {
            const response = await apiRequest('/login', 'POST', data)

            if (response.status === 200) {
                onOtpRequest(email, password)
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred')

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'))
            setPassword('')
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 500)
        }
    };

    const handleSignup = async (event) => {
        event.preventDefault()
        NavigationService.navigateTo('/signup')
    };

    return (
        <div className="tw-grid tw-gap-4">
            <Form onSubmit={handleSubmit}>
                <div className="tw-flex tw-flex-col tw-gap-1">
                    <Label htmlFor={emailInputId}>{i18next.t('common.email')}</Label>
                    <Input
                        id={emailInputId}
                        type="email"
                        placeholder="m@example.com"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="tw-flex tw-flex-col tw-gap-1">
                    <Label htmlFor={passwordInputId}>{i18next.t('common.password')}</Label>
                    <Input
                        id={passwordInputId}
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <Button type="submit" loading={loading} fullWidth tone="secondary" disabled={!formFilled}>
                    {i18next.t('ui.buttons.login')}
                </Button>
            </Form>
            <div className="tw-flex tw-justify-between tw-gap-2">
                <Link onClick={handleForgotPassword} text={i18next.t('ui.passwords.forgot_password')} variant="body"/>
                <Link href="mailto:support@wisemetering.com" target="_blank" text={i18next.t('glossary.contact_us').capitalize()} variant="body"/>
            </div>
            <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-start tw-gap-x-3 tw-gap-y-2 tw-rounded-2xl tw-border tw-border-solid tw-border-border tw-px-6 tw-py-5">
                <Text variant="caption">
                    {i18next.t('users.new_to_wisemetering')}
                </Text>
                <Link onClick={handleSignup} text={i18next.t('users.create_free_account_here')} variant="body"/>
            </div>
        </div>
    )
}
